export class Reportes {
  idSolicitud: number = 0;
  procesoElectoral: string = '';
  organo: string = '';
  usuarioDiligencia: string = '';
  recepcion: string = '';
  noPeticion: string = '';
  fechaRecepcion: string = '';
  peticionario: string = '';
  partido: string = '';
  procedimientoSancionador: string = '';
  hechosDenunciados: string = '';
  acto: string = '';
  ubicacion: string = '';
  cumpleRequisistos: string = '';
  existePrevencion: string = '';
  prevenciones: string = '';
  fechaPrevencion: string = '';
  fechaRespuesta: string = '';
  atiendePrevencion: string = '';
  fechaInicioDiligencia: string = '';
  fechaFinDiligencia: string = '';
  acta: string = '';
  fechaInicioActa: string = '';
  fechaFinActa: string = '';
  folios: string = '';
  copiasCertificadas: string = '';
  fechaExpedida: string = '';
  fechaEntrega: string = '';
  fechaDigitalizacion: string = '';
  fechaImporcedencia: string = '';
}
